export const POLL_TYPES = {
    PLAYER_OF_THE_GAME: 'POTG'
};
